import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { PROFILE_ATTRIBUTES } from '../../data/criteria';
import { SliderInput, SelectInput, NumberInput, TextAreaInput } from '../../components/forms';
export function ProfileTab() {
    const { profile, updateProfileAttribute, resetProfile } = useAppContext();
    const getValue = (attrId) => {
        const attr = profile.attributes.find(a => a.attributeId === attrId);
        return attr ? attr.value : 5;
    };
    const handleUpdate = useCallback((id, value) => {
        updateProfileAttribute(id, value);
    }, [updateProfileAttribute]);
    const technicalAttrs = PROFILE_ATTRIBUTES.filter(a => a.category === 'technical');
    const experienceAttrs = PROFILE_ATTRIBUTES.filter(a => a.category === 'experience');
    const personalityAttrs = PROFILE_ATTRIBUTES.filter(a => a.category === 'personality');
    const preferenceAttrs = PROFILE_ATTRIBUTES.filter(a => a.category === 'preference');
    const motivationAttrs = PROFILE_ATTRIBUTES.filter(a => a.category === 'motivation');
    const renderAttribute = (attr) => {
        const value = getValue(attr.id);
        switch (attr.type) {
            case 'slider':
                return (_jsx(SliderInput, { id: attr.id, label: attr.label, value: value, onChange: (v) => handleUpdate(attr.id, v), minLabel: attr.minLabel, maxLabel: attr.maxLabel, className: "brutal-slider" }, attr.id));
            case 'select':
                return (_jsx(SelectInput, { id: attr.id, label: attr.label, value: value, onChange: (v) => handleUpdate(attr.id, v), options: attr.options || [], className: "brutal-select" }, attr.id));
            case 'number':
                return (_jsx(NumberInput, { id: attr.id, label: attr.label, value: value, onChange: (v) => handleUpdate(attr.id, v), prefix: attr.id === 'capital' ? 'R$' : undefined, className: "brutal-input" }, attr.id));
            case 'textarea':
                return (_jsx(TextAreaInput, { id: attr.id, label: attr.label, value: value, onChange: (v) => handleUpdate(attr.id, v), placeholder: `${attr.label}...`, rows: 3, className: "brutal-input" }, attr.id));
            default:
                return null;
        }
    };
    const renderCategory = (title, icon, attrs) => (_jsxs("div", { style: {
            position: 'relative',
            backgroundColor: '#141414',
            border: '2px solid #333333',
            borderRadius: 0,
            padding: '1rem 1.25rem',
            marginBottom: '0.75rem',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
            transition: 'transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease'
        }, children: [_jsxs("h3", { style: {
                    fontWeight: '900',
                    color: '#999999',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontSize: '12px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }, children: [_jsx("span", { style: { fontSize: '14px' }, children: icon }), " ", title.toUpperCase()] }), _jsx("div", { style: {
                    display: 'grid',
                    gap: '0.75rem',
                    gridTemplateColumns: 'repeat(1, minmax(0, 1fr))'
                }, children: attrs.map(renderAttribute) })] }));
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }, children: [_jsxs("div", { style: { marginBottom: '0.5rem', textAlign: 'center', maxWidth: '512px', width: '100%' }, children: [_jsx("h2", { style: {
                            fontSize: '1.25rem',
                            fontWeight: '900',
                            color: '#f5f5f5',
                            textTransform: 'uppercase',
                            letterSpacing: '-0.025em',
                            marginBottom: '0.25rem'
                        }, children: "Meu Perfil Empreendedor" }), _jsx("p", { style: { fontSize: '0.875rem', color: '#999999' }, children: "Ajuste seus atributos para receber recomenda\u00E7\u00F5es personalizadas." })] }), _jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%', maxWidth: '563px' }, children: [renderCategory('Habilidades Técnicas', '⚡', technicalAttrs), renderCategory('Experiência', '💼', experienceAttrs), renderCategory('Personalidade & Motivação', '🧠', [...personalityAttrs, ...motivationAttrs]), renderCategory('Preferências', '🎯', preferenceAttrs)] }), _jsxs("div", { style: { display: 'flex', justifyContent: 'center', gap: '0.5rem', marginTop: '0.5rem', width: '100%', maxWidth: '563px' }, children: [_jsx("button", { onClick: resetProfile, style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'transparent',
                            color: '#f5f5f5',
                            fontWeight: '900',
                            border: '2px solid #333333',
                            borderRadius: 0,
                            padding: '10px 20px',
                            fontFamily: 'inherit',
                            fontSize: '13px',
                            letterSpacing: '0.02em',
                            textTransform: 'uppercase',
                            transition: 'all 0.15s ease',
                            cursor: 'pointer'
                        }, children: "Resetar" }), _jsx("button", { style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#06b6d4',
                            color: '#000000',
                            fontWeight: '900',
                            border: '2px solid #06b6d4',
                            borderRadius: 0,
                            padding: '10px 20px',
                            fontFamily: 'inherit',
                            fontSize: '13px',
                            letterSpacing: '0.02em',
                            textTransform: 'uppercase',
                            transition: 'all 0.15s ease',
                            cursor: 'pointer'
                        }, children: "Salvar" })] })] }));
}
